/**
 * Setup-pending エラーコード定数（一元管理）
 * Webhook処理待ち（新規ユーザー登録直後）の判定に使用
 */
export const SETUP_PENDING_CODES = ['USER_NOT_FOUND_SETUP_PENDING', 'TENANT_ASSIGNMENT_PENDING'] as const;
export type SetupPendingCode = typeof SETUP_PENDING_CODES[number];
